import {
  RowDataReducerAction,
  PrimitiveValueType,
  RecordsSearchFilterResponse,
} from "../../../../../types";

export const enableOrDisableAndClearSaleChainsFieldsByAccountNumber = (
  propertyKey: string,
  dispatch: React.Dispatch<RowDataReducerAction>,
  inputValue: PrimitiveValueType | undefined,
  response: RecordsSearchFilterResponse | undefined,
): void => {
  const targetKeys = ["over_allowance_sale_account", "reconditioning_account"];

  if (!inputValue || !response) return;

  const hasExpectedSubType = response.data.some(
    (row) =>
      row[propertyKey] === inputValue && row["sub_type"] === "Vehicle Sale",
  );

  targetKeys.forEach((targetKey) => {
    dispatch({
      type: "UPDATE_SCHEMA_PROPERTY_FIELD",
      payload: {
        propertyKey: targetKey,
        propertyField: "disabled",
        newPropertyFieldValue: !hasExpectedSubType,
      },
    });

    if (!hasExpectedSubType) {
      dispatch({
        type: "UPDATE_FIELD",
        payload: {
          propertyKey: targetKey,
          newFieldValue: null,
        },
      });
    }
  });
};
